import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';

import $ from 'jquery';

import {
    CharacterCounter
} from '@materializecss/materialize';

import classNames from 'classnames';

import I18n from '@js/modules/translations';
import Notification from '@js/components/theme/notification';

import 'jquery-serializejson';

import * as M from '@materializecss/materialize';

import {
    fetchBlogTags,
    addBlogArticle,
    updateBlogArticle
} from '@js/actions';

import {
    getEditingArticle
} from '@js/selectors';

import '@js/modules/validation';

import Input from '@js/components/materialize/input';
import Submit from '@js/components/materialize/submit';
import ProcessingButton from '@js/components/theme/processingButton';
import Selecter from '@js/components/loaders/selecter';
import Trumbowyg from '@js/components/loaders/trumbowyg';


class BlogForm extends React.PureComponent {
    static propTypes = {
        currentUserId: PropTypes.number,
        currentAdminId: PropTypes.number,
        isEditing: PropTypes.bool,
        isTitled: PropTypes.bool,
        isTagged: PropTypes.bool,
        onCancel: PropTypes.func,
        // From connect
        tags: PropTypes.array,
        isProcessing: PropTypes.bool,
        article: PropTypes.object,
        fetchBlogTags: PropTypes.func,
        addBlogArticle: PropTypes.func,
        updateBlogArticle: PropTypes.func
    };

    static defaultProps = {
        isEditing: false,
        isTitled: true,
        isTagged: true
    };

    constructor(props) {
        super(props);

        this._collapsible = null;
        this._blogArticleForm = React.createRef();
    }

    componentDidMount() {
        if (this.props.currentUserId) {
            this.props.fetchBlogTags(this.props.currentUserId);
        }

        this._collapsible = M.Collapsible.init(document.getElementById('blog-form-collapsible'), {
            accordion: true
        });

        if (this.props.isEditing) {
            this.expandForm();
        }

        this._handleCharacterCount();
    }

    componentDidUpdate(prevProps) {
        this._handleCharacterCount();

        if (prevProps.article !== this.props.article) {
            this.collapseForm();
        }
    }

    _handleCharacterCount = () => {
        const elems = document.querySelectorAll('input[data-length], textarea[data-length]');
        CharacterCounter.init(elems);
    };

    expandForm = () => {
        if (this._collapsible) {
            this._collapsible.open();
        }
    };

    collapseForm = () => {
        if (this._collapsible) {
            this._collapsible.close();
        }
    };

    _onCancelClick = (event) => {
        if (this.props.onCancel) {
            this.props.onCancel();
        } else {
            this.collapseForm();
        }

        return event;
    };

    _handleSubmit = (event) => {
        event.preventDefault();

        if (!this._blogArticleForm.current) {
            return;
        }

        const $articleForm = $(this._blogArticleForm.current);
        const validator = $articleForm.parsley();

        if (!validator.isValid()) {
            validator.validate();
            Notification.error(I18n.t('js.blog.common.validation_error.common'));
            return false;
        }

        const blogArticle = $articleForm.serializeJSON().blog;

        if (this.props.currentAdminId && this.props.article) {
            blogArticle.id = this.props.article.id;
            this.props.updateBlogArticle(this.props.currentAdminId, this.props.article.id, blogArticle, !!this.props.currentAdminId);
        } else if (this.props.isEditing && this.props.article.id) {
            blogArticle.id = this.props.article.id;
            this.props.updateBlogArticle(this.props.currentUserId, this.props.article.id, blogArticle)
                .then(() => this.collapseForm());
        } else {
            this.props.addBlogArticle(this.props.currentUserId, blogArticle)
                .then(() => this.collapseForm());
        }

        return true;
    };

    render() {
        return (
            <div className="row">
                <div className="col s12">
                    <ul id="blog-form-collapsible"
                        className="collapsible popout"
                        data-collapsible="accordion">
                        <li>
                            <div className={classNames('collapsible-header', {active: this.props.isEditing})}>
                                <span className="material-icons"
                                      data-icon="chat"
                                      aria-hidden="true"/>
                                {
                                    this.props.isEditing
                                        ?
                                        I18n.t('js.blog.article.edit.title')
                                        :
                                        I18n.t('js.blog.article.new.title')
                                }
                            </div>

                            <div className="collapsible-body">
                                <form ref={this._blogArticleForm}
                                      id="blog-article-form"
                                      className="loca-form"
                                      onSubmit={this._handleSubmit}>
                                    <input type="hidden"
                                           id="force_locale"
                                           name="force_locale"
                                           value={window.locale}/>

                                    <div className="row">
                                        {
                                            !!this.props.isTitled &&
                                            <div className="col s12">
                                                <Input id="blog_title"
                                                       title={I18n.t('js.blog.article.model.title')}
                                                       isRequired={true}
                                                       autoComplete="off"
                                                       maxLength={window.settings.blog_article_title_max_length}
                                                       characterCount={window.settings.blog_article_title_max_length}
                                                       validator={{
                                                           'data-parsley-required': true,
                                                           'data-parsley-minlength': window.settings.blog_article_title_min_length,
                                                           'data-parsley-maxlength': window.settings.blog_article_title_max_length
                                                       }}>
                                                    {this.props.article.title}
                                                </Input>
                                            </div>
                                        }

                                        <div className="col s12">
                                            <Trumbowyg id="blog_body"
                                                       placeholder={I18n.t('js.blog.article.model.body')}
                                                       dataModel="blog"
                                                       isRequired={true}
                                                       characterCount={window.settings.blog_article_body_max_length}
                                                       validator={{
                                                           'data-parsley-required': true,
                                                           'data-parsley-strip-html': '[' + window.settings.blog_article_body_min_length + ',' + window.settings.blog_article_body_max_length + ']',
                                                           'data-parsley-strip-html-message': I18n.t('js.blog.errors.description.size', {
                                                               min: window.settings.blog_article_body_min_length,
                                                               max: window.settings.blog_article_body_max_length
                                                           })
                                                       }}
                                                       onSubmitRequest={this._handleSubmit}>
                                                {this.props.article.body}
                                            </Trumbowyg>
                                        </div>

                                        {
                                            !!this.props.isTagged &&
                                            <div className="col s12 m6 offset-m3">
                                                <Selecter id="blog_tags"
                                                          elements={this.props.tags || []}
                                                          title={I18n.t('js.blog.article.model.tags')}
                                                          placeholder={I18n.t('js.blog.article.common.tags')}
                                                          maxValues={4}
                                                          maxLength={40}
                                                          isEditing={true}>
                                                    {!!this.props.article.tags && this.props.article.tags.map((tag) => tag.name)}
                                                </Selecter>
                                            </div>
                                        }
                                    </div>

                                    <div className="row margin-top-10">
                                        <div className="col s6">
                                            <a className="btn-flat waves-effect waves-matisse"
                                               onClick={this._onCancelClick}>
                                                {I18n.t('js.blog.article.common.form.cancel')}
                                            </a>
                                        </div>

                                        <div className="col s6 right-align">
                                            {
                                                this.props.isProcessing
                                                    ?
                                                    <ProcessingButton
                                                        title={I18n.t('js.blog.article.common.form.submitting')}/>
                                                    :
                                                    <Submit id="comment-submit"
                                                            onClick={this._handleSubmit}>
                                                        {
                                                            this.props.isEditing
                                                                ?
                                                                I18n.t('js.blog.article.common.form.submit_edit')
                                                                :
                                                                I18n.t('js.blog.article.common.form.submit')
                                                        }
                                                    </Submit>
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => ({
    tags: state.blogState.tags,
    isProcessing: state.blogArticleState.isProcessing,
    article: getEditingArticle(state, props)
}), {
    fetchBlogTags,
    addBlogArticle,
    updateBlogArticle
})(BlogForm);
